import React from "react";
import InstaImage from "./insta-image";
import Masonry from "./masonry";

export default class InstaGallery extends React.Component {
  render() {
    const { columns, images, f } = this.props;
    const instaImages = images.map(({ url }) => {
      return {
        span: 1,
        element: (
          <InstaImage f={f} url={url} key={url} onLoad={this.updateLayout} />
        )
      };
    });

    return (
      <div>
        <Masonry columns={columns} gutter="4%" elements={instaImages} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/insta-gallery.js